import React, { FC } from 'react';
import { useModal } from 'store/modal';
import API from 'core/Api';
import Button from 'components/Button';
import TooltipWrapper from 'components/TooltipWrapper';
import { useTranslation } from 'react-i18next';
import { FaTrash } from 'react-icons/fa';
import { createErrorFromResponse } from 'core/Error';
import useInvalidateQueries from 'utils/helpers/useInvalidateQueries';

interface IProps {
  children?: any;
  id: string;
  buttonText: string;
  disabled: boolean;
  className?: string;
  invalidate: () => void;
}

const DeleteDoc: FC<IProps> = ({ id, buttonText, disabled, invalidate, className }: IProps) => {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const invalidateQueries = useInvalidateQueries();

  // Delete document
  const handleDelete = (docId: string) =>
    API.post(`document-holders/${docId}/move-to-bin`)
      .then(() => {
        showModal({
          type: 'success',
          content: t('documents.table.deletedDocSuccessMsg'),
        });
        invalidateQueries([], invalidate);
      })
      .catch(err =>
        showModal({
          type: 'error',
          content: createErrorFromResponse(err).message,
        })
      );

  // Confirm delete
  const confirmDelete = (docId: string) => {
    showModal({
      type: 'confirm',
      heading: t('documents.table.confirmDeleteDocHeading'),
      content: t('documents.table.confirmDeleteDocMsg'),
      onConfirm: () => handleDelete(docId),
      confirmLabel: t('documents.table.confirmDeleteDocLabel'),
    });
  };

  const containerClass = className || 'ml-3';

  return (
    <div className={`d-inline-block ${containerClass}`}>
      <TooltipWrapper
        id="tooltip-delete"
        overlay={buttonText}
      >
        <Button
          type="button"
          btnType="icon"
          disabled={disabled}
          onClick={e => {
            confirmDelete(id);
            e.stopPropagation();
          }}
        >
          <FaTrash size={18} />
        </Button>
      </TooltipWrapper>
    </div>
  );
};

export default DeleteDoc;
